export default '6FCC8';
